var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcPlayerFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.434 11.022L8.767 4.164a1.19 1.19 0 00-1.174-.015A1.14 1.14 0 007 5.143v13.715c0 .413.226.792.591.996a1.197 1.197 0 001.176-.015l11.667-6.857c.351-.207.566-.578.566-.98 0-.401-.215-.773-.566-.98z",
    fill: "#0373F9"
  })));
}

export default "data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M20.4342 11.0224L8.7675 4.16363C8.407 3.95222 7.959 3.94651 7.59267 4.14877C7.22633 4.35218 7 4.73157 7 5.14296V18.8582C7 19.2708 7.22633 19.6502 7.5915 19.8536C7.77117 19.9518 7.96833 20.001 8.16667 20.001C8.37433 20.001 8.58317 19.9473 8.7675 19.8387L20.4342 12.9822C20.7853 12.7754 21 12.404 21 12.0017C21 11.6006 20.7853 11.2292 20.4342 11.0224Z' fill='%230373F9'/%3E %3C/svg%3E";
export { SvgIcPlayerFill as ReactComponent };